import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Main from '../Main';
import Xero from '../Xero';
import Empty from '../Empty';
import LoadingPage from '../LoadingPage';
import { actions as categoriesActions } from '../../services/categoryService/actions';
import { getAccountActions } from '../../services/accountService/actions';
import { getXeroBankAccountsActions } from '../../services/xeroService/actions';
import styles from './Company.module.css';
import { setTokenAction, setAuthCompletedAction, setAuthInProgressAction } from '../../services/appService/actions';
import { checkAuth } from '../../common/auth';

class Company extends Component {
  componentDidMount() {
    const {
      actions: {
        loadXeroBankAccounts, loadCategories, getAccount, setToken,
        setAuthInProgress, setAuthCompleted,
      },
    } = this.props;
    setAuthInProgress();
    checkAuth()
      .then((data) => {
        if (data) {
          setToken(data.token);
          loadCategories();
          getAccount();
          loadXeroBankAccounts();
        }
      })
      .finally(() => {
        setAuthCompleted();
      });
  }

  render() {
    const { error, authInProgress } = this.props;

    if (error) {
      return (
        <div className={styles.Error}>
          <div className={styles.ErrorText}>
            <p>
              Something went wrong here.
            </p>
            <p>
              Please refresh the page and if it doesn&apos;t help – let us know via in-app chat.
            </p>
          </div>
        </div>
      );
    }

    if (authInProgress) {
      return <LoadingPage size="xxl" />;
    }

    return (
      <Switch>
        <Route
          path="/company/:companyId/xero"
          component={
                  ({ match }) => (
                    <Xero
                      match={match}
                    />
                  )
                }
        />
        <Route
          path="/company/xero"
          component={
                  ({ match }) => (
                    <Xero
                      match={match}
                    />
                  )
                }
        />
        <Route
          path="/company/:companyId"
          component={
                  ({ match }) => (
                    <Main match={match} />
                  )
                }
        />
        <Route
          exact
          path="/company"
          component={
                  ({ match }) => (
                    <Main match={match} />
                  )
                }
        />
        <Route component={Empty} />
      </Switch>
    );
  }
}

Company.propTypes = {
  actions: PropTypes.shape({
    loadXeroBankAccounts: PropTypes.func.isRequired,
    loadCategories: PropTypes.func.isRequired,
    getAccount: PropTypes.func.isRequired,
    setToken: PropTypes.func.isRequired,
    setAuthInProgress: PropTypes.func.isRequired,
    setAuthCompleted: PropTypes.func.isRequired,
  }).isRequired,
  error: PropTypes.shape({
    response: PropTypes.shape({
      status: PropTypes.number.isRequired,
    }),
  }),
  authInProgress: PropTypes.bool.isRequired,
};

Company.defaultProps = {
  error: null,
};

const mapStateToProps = ({ accountService }) => ({
  error: accountService.error,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    loadCategories: categoriesActions.common,
    getAccount: getAccountActions.common,
    loadXeroBankAccounts: getXeroBankAccountsActions.common,
    setToken: setTokenAction,
    setAuthCompleted: setAuthCompletedAction,
    setAuthInProgress: setAuthInProgressAction,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Company);
